var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-input-number", {
        attrs: { controls: false, precision: 2, min: 0, size: "mini" },
        model: {
          value: _vm.form.length,
          callback: function($$v) {
            _vm.$set(_vm.form, "length", $$v)
          },
          expression: "form.length"
        }
      }),
      _c("span", [_vm._v("CM")]),
      _c("span", [_vm._v("*")]),
      _c("el-input-number", {
        attrs: { controls: false, precision: 2, min: 0, size: "mini" },
        model: {
          value: _vm.form.width,
          callback: function($$v) {
            _vm.$set(_vm.form, "width", $$v)
          },
          expression: "form.width"
        }
      }),
      _c("span", [_vm._v("CM")]),
      _c("span", [_vm._v("*")]),
      _c("el-input-number", {
        attrs: { controls: false, precision: 2, min: 0, size: "mini" },
        model: {
          value: _vm.form.height,
          callback: function($$v) {
            _vm.$set(_vm.form, "height", $$v)
          },
          expression: "form.height"
        }
      }),
      _c("span", [_vm._v("CM")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }